import { render, staticRenderFns } from "./visualizerPdfImage.vue?vue&type=template&id=4ddbcb04&scoped=true"
import script from "./visualizerPdfImage.vue?vue&type=script&lang=js"
export * from "./visualizerPdfImage.vue?vue&type=script&lang=js"
import style0 from "./visualizerPdfImage.vue?vue&type=style&index=0&id=4ddbcb04&prod&scoped=scss&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddbcb04",
  null
  
)

export default component.exports